import React from "react";
import ReactMarkdown from "react-markdown";
import "./styles.css";

/**
 * Markdown links are built by react-markdown, not by Linkify, so they miss the
 * target Linkify adds by default. In the operator panel that meant a click
 * navigated the whole dashboard away, losing every open chat.
 */
const renderers = {
    link: ({href, children}) => (
        <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>
    ),
};

function MarkdownRenderer({content = ""}) {
    return (
        <div className="markdown-body">
            <ReactMarkdown
                source={content}
                escapeHtml={false}
                renderers={renderers}
            />
        </div>
    );
}

export default MarkdownRenderer;



// WEBPACK FOOTER //
// ./src/components-new/general/MarkdownRenderer/index.jsx